// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2CJNj","balanceDisclaimer":"posDashboard_balanceDisclaimer__1b88T"};